<template>
  <div class="my-patients-wrapper">
    <div class="patients-search">
      <form @submit.prevent="searchPatient" action="" class="search-box">
        <icon icon-class="search"></icon>
        <input type="search" placeholder="请搜索患者姓名" v-model="searchKey" name="" id="">
        <icon icon-class="close" class="clear" @click.native="clearSearch" v-show="searchKey"></icon>
      </form>
      <div class="select-box"></div>
    </div>
    <div class="list-loading" v-if="!dataDone">
      <van-loading type="spinner" size="14px">正在加载中...</van-loading>

    </div>
    <div class="patients-list" v-else-if="dataDone && patientsList.length > 0">
      <div class="patient-item" :key="index" v-for="(item, index) in patientsList">
        <div class="pat-item-control" :class="{'selected': arr.includes(item.pat_id)}" @click="selectItem(item.pat_id)"
          v-if="patsSelecter">
          <icon icon-class="anwser-checked" v-if="arr.includes(item.pat_id)"></icon>
        </div>
        <div class="patient-box" @click="toUser(item)">
          <div class="avatar"><img :src="item.avatar"></div>
          <div class="patient-info">
            <div class="head-info">
              <div class="head-left-info">
                <div class="name">{{item.username}}</div>
                <span class="info">{{item.gender | genderFilter}} | {{item.birthday | ageFilter}} </span>
              </div>
              <div class="status-tag reserved" v-if="item.status == 1">已预约</div>
              <div class="status-tag waitting" v-if="item.status == 2">待诊疗</div>
              <div class="status-tag ing" v-if="item.status == 3">诊疗中</div>
            </div>
            <div class="info-province">{{item.province }} </div>
            <div class="date">
              <span v-if="item.status">
                复诊时间: {{item.start_time | dateFilter('month')}}
                <span v-if="item.enroll_type == 1">-{{item.end_time | timeFilter}}</span>
                <span v-if="item.enroll_type == 2">-{{item.end_time | dateFilter('month')}}</span>
              </span>
              <span v-else>上次就诊: {{item.start_time | dateFilter('month')}}</span>
            </div>
          </div>

        </div>
      </div>

    </div>
    <div class="empty-patients" v-else-if="dataDone && patientsList.length == 0">
      <icon icon-class="empty-patient"></icon>
      <p>暂时还没有患者</p>
    </div>
    <div class="btn-bot-pannel"><!-- v-if="userInfo.user_id==10032"-->

      <div class="btn-bot-control" v-if="!patsSelecter">
        <div class="btn-item" @click="showSelect(1)">诊疗券</div>
        <div class="btn-dot"></div>
        <div class="btn-item" @click="showSelect(2)">加号条</div>
      </div>
      <div class="btn-bot-control" v-else>
       <div class="btn-left-item" :class="{'selected':selectAllItem }" @click="selectAll()">全选</div>
        <div class="btn-right-item" :class="{'selected':arr.length>0 }" @click="confirmSend()">确定发放</div>

        <div class="btn-dot"></div>
        <div class="btn-right-item selected" @click="cancelSelect()">取消</div>

      </div>
    </div>
    <!-- 发放诊疗劵确认弹窗 -->
    <x-dialog v-if="sendDiagnoseShow" title="发送诊疗券" @close="sendDiagnoseShow = false">
      <div class="dialog-content">
        <!--
        <div class="warning-text" >当前处方用量超过7天，请确认已知晓，并将处方发送给患者</div>-->
        <div class="text">确认给{{arr.length}}人发送诊疗券</div>
        <div class="control">
          <button class="cancel" @click="sendDiagnoseShow = false">取消</button>
          <button class="confirm" @click="sendDiagnose">确定</button>
        </div>
      </div>
    </x-dialog>
    <!-- 选择开方剂型弹窗 -->
    <van-popup v-model="choosePanel" position="bottom">
      <div class="popup-wrapper">
        <div class="popup-header">
          日程设置
          <span class="left-control" @click="choosePanel = false">取消</span>
          <span class="right-control" @click="saveAppoint()">确定</span>
        </div>
        <div class="formulation-wrapper">
          <div class="edit-form">
            <div class="edit-item">
              <div class="edit-type required"><span>输入出诊地点</span></div>
              <div class="title-typer">
                <input type="text" class="script-title-input" v-model="location" placeholder="请输入出诊地点" maxlength="20">
              </div>
            </div>
            <div class="edit-item">
              <div class="edit-type required"><span>选择坐诊日期</span></div>
              <div class="edit-content">
                <div class="date-picker" @click="datePickerShow = true">
                  <span class="placeholder" v-if="!scheduleDate">请选择坐诊日期</span>
                  <span class="value" v-else>{{scheduleDate | dateFilter}}</span>
                </div>
              </div>
            </div>
            <div class="edit-item">
              <div class="edit-type required"><span>选择时间段</span></div>
              <div class="edit-content">
                <div class="time-selector">
                  <div class="selector-item" :class="{'selected': timepos == 1}" @click="chooseTime(1)">上午</div>
                  <div class="selector-item" :class="{'selected': timepos == 2}" @click="chooseTime(2)">下午</div>
                </div>
              </div>
            </div>
            <!--
            <div class="edit-item">
              <div class="edit-type required"><span>选择坐诊时间段</span></div>
              <div class="edit-content">
                <div class="time-picker" @click="pickStartTime">
                  <span class="placeholder" v-if="!startTime">开始时间</span>
                  <span class="value" v-else>{{startTime}}</span>
                </div>
                <div class="line"></div>
                <div class="time-picker" @click="pickEndTime">
                  <span class="placeholder" v-if="!endTime">结束时间</span>
                  <span class="value" v-else>{{endTime}}</span>
                </div>
              </div>
            </div>
            -->
          </div>
        </div>

      </div>
    </van-popup>
    <!-- 弹出层 -->
    <!-- 日期选择 -->
    <van-popup v-model="datePickerShow" position="bottom">
      <van-datetime-picker type="date" :min-date="minDate" :max-date="maxDate" @confirm="confirmDate" @cancel="datePickerShow = false" />
    </van-popup>
    <!-- 开始时间选择
    <van-popup v-model="startTimePickerShow" position="bottom">
      <van-datetime-picker type="time" :filter="timeFilter" :min-hour="minStartTime" :min-minute="minStartMinute"
        @confirm="confirimStartTime" @cancel="startTimePickerShow = false" />
    </van-popup>-->
    <!-- 结束时间选择
    <van-popup v-model="endTimePickerShow" position="bottom">
      <van-datetime-picker type="time" :filter="timeFilter" :min-hour="minEndTime" :min-minute="minEndMinute" @confirm="confirimEndTime"
        @cancel="endTimePickerShow = false" @change="endTimeChange" />
    </van-popup>-->
  </div>
</template>

<style lang="less" scoped>
  .popup-header{
      position: relative;
      .left-control{
        position: absolute;
        top: 50%;
        left: 16px;
        transform: translateY(-50%);
        font-size: 15px;
        color: @black;
        font-weight: normal;
        background: transparent;
        border: 0;
        padding:3px 10px;
        line-height: 20px;
      }
      .right-control{
        position: absolute;
        top: 55%;
        right: 16px;
        transform: translateY(-50%);
        font-size: 15px;
        color:@xile;
        font-weight: normal;
        background: transparent;
        border: solid 1px #3668A6;
        border-radius: 3px;
        font-weight: bold;
        border-radius: 3px;
        padding:3px 18px;
        box-shadow: 0px 2px 3px 0px rgba(51,51,51,0.08);
      }
  }

  .formulation-wrapper{
    padding:0px 5px 0;
    height: 100%;
    min-height: 600px;
    .edit-form{
      background: #FFF;
      padding: 24px 0 0;
      .edit-item{
        padding: 0 0 12px 20px;
        .title-typer{
          position: relative;
          top: 2px;
          flex: 1;
          line-height: 30px;
          display: flex;
          align-items: center;
          input{
            padding: 0;
            line-height: 30px;
            width: 100%;
            font-size: 15px;
            height: 40px;
          }
        }
        .edit-type{
          span{
            position: relative;
            font-size: 15px;
            line-height: 15px;
            color: #666;
            font-weight: bold;
            &::after{
              content: '*';
              position: absolute;
              left: 100%;
              top: 0;
              font-size: 14px;
              line-height: 14px;
              color: @error;
              margin-left: 2px;
              font-weight: bold;
            }
          }
        }
        .edit-content{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .date-picker, .time-picker, .number-typer{
            padding: 14px 0;
          }
          .date-picker, .number-typer{
            width: 100%;
          }
          .placeholder{
            font-size: 15px;
            line-height: 15px;
            // font-weight: bold;
            color: #999;
          }
          .value{
            font-size: 15px;
            line-height: 15px;
            // font-weight: bold;
            color: @black;
          }
          .line{
            margin: 0 16px;
            width: 20px;
            height: 1px;
            background: #CCC;
          }
          .time-selector{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-top:10px;
            .selector-item{
              height: 32px;
              padding: 0 20px;
              display: flex;
              justify-content: center;
              align-items: center;
              border: 1px solid #E0E6E6;
              background: #F7F7F7;
              color: #999;
              font-size: 14px;
              cursor: pointer;
              border-radius: 4px;
              transition: all .1s;
              &:first-child{
              margin-right: 16px;
              }
              &.selected{
                border-color: @xile;
                background: @xile;
                color: #FFF;
              }
            }
          }


        }
      }
    }
  }
  .my-patients-wrapper{
    .dialog-content{
      padding: 40px 0 32px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .warning-text{
        width: 80%;
        font-size: 15px;
        line-height: 21px;
        font-weight: bold;
        color: @black;
      }
      .text{
        font-size: 16px;
        line-height: 16px;
        color: @black;
        font-weight: bold;
        span{
          margin-left: 4px;
          color: @error;
        }
      }
      .control{
        margin-top: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
        button{
          @button-base();
          height: 36px;
          font-size: 14px;
          width: 136px;
          &.cancel{
            background: #FFF;
            border: 1px solid #999;
            color: #999;
            margin-right: 15px;
          }
          &.confirm{}
        }
      }
    }
    .btn-bot-pannel{
      position: fixed;
      width: 100%;
      height: 45px;
      bottom:0;
      left: 0;
      border-top: solid 1px #ebebeb;
      background-color: #ffffff;;
      box-shadow: 1px 3px  3px 1px #ececec;
      .btn-bot-control{
        display: flex;
        justify-content: space-around;
        width: 100%;
        height: 45px;

      }
      .btn-item{
        height: 35px;
        margin:5px auto 5px auto;
        text-align: center;
        color:#474747;
        font-size: 14px;
        line-height: 35px;
        font-weight: bold;
        color:@xile;
        width: 100%;

      }
      .btn-right-item{
        height: 35px;
        text-align: center;
        color:#a3a3a3;
        font-size: 14px;
        line-height: 35px;
        font-weight: bold;
        color:676767;
        border-radius: 3px;
        padding:0px 20px;
        margin-right: 5px;;
        margin-top: 5px;
        &.selected{
          color:@xile;
        }
      }

      .btn-left-item{
        height: 35px;
        text-align: center;
        color:#474747;
        font-size: 14px;
        line-height: 35px;
        color:#676767;
        margin:5px auto 5px 20px;
        font-weight: 600;
        &.selected{
          color:@xile;
        }
      }
      .btn-dot{
        width: 1px;
        border-left: solid 1px #ccc;
        height: 20px;
        margin-top:12px;
      }
    }

    .list-loading{
      padding-top: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .empty-patients{
      padding-top: 220px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #CCC;
      text-align: center;
      flex-direction: column;
      svg{
        font-size: 72px;
      }
      p{
        margin-top: 12px;
        font-size: 15px;
        line-height: 15px;
      }
    }
    .patients-search{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 57px;
      border-bottom: 1px solid #F2F0EC;
      padding: 12px 16px;
      background: #FFF;
      z-index: 10;
      display: flex;
      justify-content: flex-start;

      .search-box{
        width: 100%;
        height: 32px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        background: #F7F7F7;
        border-radius: 4px;
        overflow: hidden;


        svg{
          font-size: 16px;
          color: #CCC;
          margin-left: 13px;
          &.clear{
            color: #999;
            margin-right: 8px;
            font-size: 14px;
          }
        }
        input{
          flex: 1;
          height: 100%;
          background: #F7F7F7;
          font-size: 14px;
          color: @black;
          padding: 0 8px;
          &[type=search]::-webkit-search-cancel-button{
            -webkit-appearance: none;
          }
        }
      }

    }
    .patients-list{
      padding-top: 57px;
      width: 100%;
      .patient-item{
        width: 100%;
        transition: all .1s;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        .pat-item-control{
          width: 25px;
          height: 25px;
          border-radius: 50%;
          border:solid 1px #EEEEEE;
          margin:30px 0px 0px 10px;
          background-color: #e3e3e3;
          line-height: 25px;
          text-align: center;
          &.selected{
            margin:30px 0px 0px 10px;
            background-color:#3668A6;
            border:solid 1px #3668A6;
            text-align: center;
            width: 25px;
            height: 25px;
            border-radius: 50%;
            line-height: 25px;
            color:#fff;
          }
        }
        &:active{
          background: #F9F9F9;
        }
        .patient-box{
          margin-left: 16px;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          border-bottom: 1px solid #EEE;
          padding: 14px 16px 14px 0;
          width: 100%;
          .avatar{
            width: 44px;
            height: 44px;
            overflow: hidden;
            border-radius: 50%;
            background: #F9F9F9;
            flex-shrink: 0;
            img{
              width: 100%;
            }
          }
          .patient-info{
            flex: 1;
            padding: 4px 0 0 12px;
            .head-info{
              display: flex;
              justify-content: space-between;
              align-items: center;
              line-height: 16px;
              .head-left-info{
                display: flex;
                justify-content: flex-start;
                align-items: baseline;
                .name{
                  font-size: 16px;
                  color: @black;
                }
                .info{
                  margin-left: 8px;
                  color: #666;
                  font-size: 14px;
                }
              }
              .status-tag{
                position: relative;
                // top: -2px;
                display: flex;
                justify-content: center;
                height: 16px;
                font-size: 12px;
                line-height: 18px;
                color: #FFF;
                padding-left: 9px;
                &::after{
                  content: '';
                  position: absolute;
                  top: 50%;
                  left: 0;
                  transform: translateY(-50%);
                  width: 4px;
                  height: 4px;
                  border-radius: 50%;
                  background: #CCC;
                }
                &.reserved{
                  color: #E2AD2E;
                  &::after{
                    background: #E2AD2E;
                  }
                }
                &.ing{
                  color: #00848A;
                  &::after{
                    background: #00848A;
                  }
                }
                &.waitting{
                  color: @xile;
                  &::after{
                    background: @xile;
                  }
                }
              }
            }
            .info-province{
              margin-top: 6px;
              font-size: 12px;
              line-height: 14px;
              color: #666666;
            }
            .date{
              margin-top: 8px;
              font-size: 14px;
              line-height: 14px;
              color: #999;
            }
          }
        }
      }
    }
  }
</style>

<script type="text/javascript">
  import xDialog from '@/components/Common/dialog'
  import stepper from '@/components/Common/stepper'
  export default {
    data() {
      return {
        dataDone: false,
        searchKey: '',
        patientsList: [],
        arr: [],
        patsSelecter: false,
        selectAllItem: false,
        sendDiagnoseShow: false,
        sendType: 0,

        choosePanel: false,
        isToday: false,
        scheduleDate: null,
        minDate: new Date(),
        datePickerShow: false,
       /*
        // 开始时间
        startTime: null,
        minStartTime: 0,
        minStartMinute: 0,
        startTimePickerShow: false,
        // 结束时间
        endTime: null,
        minEndTime: 1,
        minEndMinute: 0,
        endTimePickerShow: false,
*/
        location:'',
        timepos:0
      }
    },
    components: {
      xDialog,
      stepper
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
      maxDate() {
        let nowDate = new Date();
        let year = nowDate.getFullYear() + 1;
        let month = nowDate.getMonth() + 1;
        let date = nowDate.getDate();
        return new Date(year, month, date);
      }
    },
    created() {
      this.getPatientList();

    },
    methods: {
      //确定保存加号券信息
      saveAppoint(){
        let _this=this;
        if(!this.location) {
          this.$notify('请输入坐诊地点');
          return;
        }else if(!this.scheduleDate) {
          this.$notify('请选择坐诊日期');
          return;
        }else if(!this.timepos) {
          this.$notify('请选择坐诊时间段');
          return;
        }
        console.log(this.location);
        console.log(this.scheduleDate)
       // console.log(this.startTime);
        //console.log(this.endTime)
        const dateString = moment(this.scheduleDate).format('YYYY-MM-DD');

        console.log(dateString)

        const dateTime=moment(this.scheduleDate).unix();
        console.log(dateTime);
        //const startTimeStamp = moment(`${dateString} ${this.startTime}`, 'YYYY-MM-DD HH:mm').unix();
        //const endTimeStamp = moment(`${dateString} ${this.endTime}`, 'YYYY-MM-DD HH:mm').unix();
        //console.log(startTimeStamp);
        //console.log(endTimeStamp)

        if (this.arr.length > 0) {
          this.$root.post('/AppointCreate', {
            doc_id: this.userInfo.user_id,
            pat_arr: this.arr,
            time_pos:this.timepos,
            location:this.location,
            time_start:dateTime
          }).then(data => {
            if (data.status) {
              _this.$notify({
                background: '#00848A',
                message: '加号条发放成功'
              });
              _this.choosePanel=false;
              _this.cancelSelect();
            } else {
              _this.$notify(data.msg)
            }
          })
          this.sendDiagnoseShow = false;
        }

      },
      chooseTime(time){
        this.timepos=time;
      },
      //确认发送诊疗券
      sendDiagnose() {
        let _this = this;
        if (this.arr.length > 0) {
          this.$root.post('/createDocCoupon', {
            doc_id: this.userInfo.user_id,
            pat_arr: this.arr
          }).then(data => {
            if (data.status) {
              _this.$notify({
                background: '#00848A',
                message: '诊疗券发放成功'
              });
              _this.cancelSelect();
            } else {
              _this.$notify(data.msg)
            }
          })
          this.sendDiagnoseShow = false;
        }


      },
      confirmSend() {
        if (this.arr.length > 0) {
          switch (this.sendType) {
            case 1:
              this.sendDiagnoseShow = true;
              break;
            case 2:
              this.choosePanel = true;
              break;
          }
        }
        //else{
        //this.$notify('请选择发放人')
        // }
      },
      selectAll() {
        let _this = this;
        if (this.selectAllItem) {
          this.arr = [];

        } else {
          _this.arr = [];
          this.patientsList.forEach(function(item, index) {
            _this.arr.push(item.pat_id)
          })
        }
        this.selectAllItem = !this.selectAllItem;
        console.log(_this.arr)
      },
      showSelect(type) {
        this.patsSelecter = true;
        this.sendType = type;
      },
      cancelSelect() {
        this.patsSelecter = false;

        this.sendType = 0;
        this.arr = [];
        if(this.selectAllItem){
          this.selectAllItem=false
        }
      },
      getPatientList(type = 'normal', cb) {
        this.$root.post('/getPatient', {
          doc_id: this.userInfo.user_id,
          search: this.searchKey
        }).then(data => {
          console.log('list')
          console.log(data)
          this.dataDone = true;
          if (data && data.length <= 0 && type == 'search' && this.patientsList.length > 0) {
            this.$notify('暂无搜索结果');
          }
          if (data && data.length > 0) {
            this.patientsList = data;
            this.patientsList.forEach(item => {
              item.selected = false;
            })
          }
          if (cb) cb();
        })
      },
      searchPatient() {
        this.$toast.loading({
          duration: 0,
          loadingType: 'spinner',
          message: '搜索中...'
        })
        this.getPatientList('search', () => {
          this.$toast.clear();
        });
      },
      clearSearch() {
        this.searchKey = '';
        this.getPatientList('search');
      },
      selectItem(i) {
        if (this.arr.includes(i)) {
          this.arr = this.arr.filter(function(ele) {
            return ele != i;
          });
        } else {
          this.arr.push(i);
        }

        if (this.selectAllItem) {
          this.selectAllItem = false
        }
        console.log(this.arr)
      },
      toUser(item) {
        this.$router.push({
          name: 'PatientRecord',
          params: {
            id: item.pat_id
          }
        })
      },
      //选择日期 时间相关
      setToday() {
        const today = moment().format('YYYY-MM-DD');
        if (moment(this.scheduleDate).format('YYYY-MM-DD') == today) {
          this.isToday = true;
          this.minStartTime = moment().hour();
          this.minEndTime = moment().hour() + 1;
        } else {
          this.isToday = false;
          this.minStartTime = 0;
          this.minEndTime = 1;
        }
      },
      timeFilter(type, options) {
        if (type === 'minute') {
          return options.filter(option => option % 10 === 0)
        }
        return options;
      },
      pickStartTime() {
        this.setToday();
        if (this.isToday && moment().minute() >= 50) {
          this.minStartTime = moment().hour() + 1;
        }
        this.startTimePickerShow = true;
      },
      pickEndTime() {
        this.endTimePickerShow = true;
        if (this.startTime) {
          let halfHour = moment(this.startTime, 'HH:mm').minute() + 30;
          if (halfHour >= 60) {
            let leftTime = halfHour - 60;
            this.minEndTime = moment(this.startTime, 'HH:mm').hour() + 1;
            this.minEndMinute = parseInt(0 + leftTime);
          } else {
            this.minEndTime = moment(this.startTime, 'HH:mm').hour();
            this.minEndMinute = moment(this.startTime, 'HH:mm').minute() + 30;
          }
        }
      },
      endTimeChange(picker) {
        // 结束时间选择分钟变化
        let value = picker.getValues();
        if (parseInt(value[0]) == this.minEndTime) {
          if (this.startTime) {
            let halfHour = moment(this.startTime, 'HH:mm').minute() + 30;
            if (halfHour >= 60) {
              let leftTime = halfHour - 60;
              this.minEndMinute = parseInt(0 + leftTime);
            } else {
              this.minEndMinute = moment(this.startTime, 'HH:mm').minute() + 30;
            }
          }
          // this.minEndMinute = this.startTime ? moment(this.startTime, 'HH:mm').minute() : 0;
        } else {
          this.minEndMinute = 0
        }
      },
      // 确认选择日期
      confirmDate(value) {
        this.scheduleDate = value;
        // 如果为今天的话不能选择之前的时间段
        this.setToday();
        this.datePickerShow = false;
      },
      confirimStartTime(value) {
        const hour = moment(value, 'HH:mm');
        const now = moment();
        if (this.endTime) {
          if (hour.hour() > moment(this.endTime, 'HH:mm').hour()) {
            this.$notify('开始时间不能大于结束时间');
            return;
          }
          if (hour.hour() == moment(this.endTime, 'HH:mm').hour() && hour.minute() >= moment(this.endTime, 'HH:mm').minute()) {
            this.$notify('开始时间不能大于结束时间');
            return;
          }
        }
        if (this.isToday && hour.isBefore(now)) {
          this.$notify('不能选择早于现在的时间');
          return;
        }
        this.startTime = value;
        // 设置结束时间 至少一小时
        this.minEndTime = hour.hour() + 1;
        this.startTimePickerShow = false;
      },
      confirimEndTime(value) {
        console.log(value)
        this.endTime = value;
        this.endTimePickerShow = false;
      }
    },
    filters: {
      dateFilter(value) {
        //return moment(value).format('MM月DD日');
        return  moment.unix(value).format('MM月DD日')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/MinePatients/index.vue